module.exports = __webpack_public_path__ + "static/media/IMG_1862.bd43f72b.JPG";